import React, { useEffect, useState } from "react";
import { getDeliverySummaryByCustomer } from "../../services/deliveryService";
import Loader from "../../components/Loader"; // ✅ import loader

const ReportCustomerDeliverySummary = () => {
  const [groupedData, setGroupedData] = useState({});
  const [loading, setLoading] = useState(true);

  const fetchDeliverySummary = async () => {
    try {
      const res = await getDeliverySummaryByCustomer();
      const rawData = res.data || [];

      // Grouping by customer_id
      const grouped = {};
      rawData.forEach((entry) => {
        const custId = entry.customer_id;
        if (!grouped[custId]) {
          grouped[custId] = {
            customer: entry.customer,
            products: [],
          };
        }
        grouped[custId].products.push({
          product_name: entry.product?.product_name,
          quantity: entry.total_quantity,
        });
      });

      setGroupedData(grouped);
    } catch (error) {
      console.error("Error fetching delivery summary:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDeliverySummary();
  }, []);

  useEffect(() => {
    fetchDeliverySummary();
  }, []);

  return (
    <div className="p-2 sm:p-2">
      <h2 className="text-xl font-bold mb-4 text-center text-white bg-blue-600 py-2 rounded-md shadow">
        🧾 Customer Delivery Summary
      </h2>

      {loading ? (
         <Loader /> // ✅ Show loader while fetching data
      ) : Object.keys(groupedData).length === 0 ? (
        <p className="text-center text-gray-300">No records found.</p>
      ) : (
        <div className="flex flex-col gap-4">
          {Object.entries(groupedData).map(([custId, group]) => (
            <div
              key={custId}
              className="bg-white rounded-xl shadow-md p-0.5 border border-gray-200"
            >
              <div className="mb-2">
                <h3 className="text-lg font-semibold text-gray-800">
                  👤 {group.customer.name}
                </h3>
                <p className="text-sm text-gray-500">
                  📱 {group.customer.mobile}
                </p>
              </div>

              <div className="overflow-x-auto">
                <table className="w-full table-auto border text-xs">
                  <thead>
                    <tr className="bg-gray-100 text-left">
                      <th className="px-1 py-1 border border-gray-300">
                        🧪 Product
                      </th>
                      <th className="px-1 py-1 border border-gray-300">
                        📦 Qty
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {group.products.map((prod, i) => (
                      <tr key={i} className="hover:bg-gray-50">
                        <td className="px-1 py-1 border border-gray-200 text-gray-800">
                          {prod.product_name}
                        </td>
                        <td className="px-1 py-1 border border-gray-200 text-gray-800">
                          {prod.quantity}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ReportCustomerDeliverySummary;
